/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvFormLabelSignature {
  Args: {
    hidden?: boolean;
    labelFor: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvFormLabelComponent = templateOnlyComponent<BvFormLabelSignature>();

export default BvFormLabelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFormLabel: typeof BvFormLabelComponent;
    'bv-form-label': typeof BvFormLabelComponent;
  }
}
